import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';

import {logWithSentry} from 'libs/sentry/sentry';

/**
 * When user called himself error in Google Pay widget
 */
export const googlePayOnCancel = (error: google.payments.api.PaymentsError) => {
    if (error.statusCode === 'CANCELED') {
        sendDesktopAnalyticsEvent(
            CHECKOUT_PAYMENT_STEP,
            {
                message: `Close`,
                method: 'Google Pay',
            },
            true,
        );
    } else if (error.statusMessage || error.statusCode) {
        sendDesktopAnalyticsEvent(
            CHECKOUT_PAYMENT_STEP,
            {
                message: `onCancel - ${error.statusCode} - ${error.statusMessage}`,
                method: 'Google Pay',
            },
            true,
        );
    } else {
        sendDesktopAnalyticsEvent(
            CHECKOUT_PAYMENT_STEP,
            {
                message: `${error}`,
                method: 'Google Pay',
            },
            true,
        );
    }
};

/**
 * When user get error in Google Pay widget
 */
export const googlePayOnError = (error: google.payments.api.PaymentsError | Error) => {
    if ('statusCode' in error) {
        sendDesktopAnalyticsEvent(
            CHECKOUT_PAYMENT_STEP,
            {
                message: `Error – ${error.statusMessage}`,
                method: 'Google Pay',
            },
            false,
        );
    } else {
        logWithSentry(error, 'GooglePay - checkout');
    }
};
